// extracted by mini-css-extract-plugin
export default {"bank":"Bank_bank__dm225","label":"Bank_label__+Q29d"};